import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';

// @material-ui/icons
import School from '@material-ui/icons/School';
import AddAlert from '@material-ui/icons/AddAlert';
import Email from '@material-ui/icons/Email';
import LockOutlined from '@material-ui/icons/LockOutlined';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Checkbox from '@material-ui/core/Checkbox';

// core components
import Button from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import ItemGrid from 'components/Grid/ItemGrid';
import IconCard from 'components/Cards/IconCard';
import CustomInput from 'components/CustomInput/CustomInput';
import CustomPasswordInput from '../../components/CustomInput/CustomPasswordInput';
import SearchBar from 'components/SearchBar/SearchBar';
import ErrorBoundaries from 'components/Wrapper/ErrorBoundaries';
import Snackbar from 'components/Snackbar/Snackbar';

// others
import FormHOC from 'hoc/FormHOC';
import { Context } from 'context/Context';
import detailsPageStyle from 'views/Common/style/detailsPageStyle';
import { transformPhone } from 'helpers/helpers';

class AssociationRegister extends Component {
  state = {};

  componentWillUnmount() {
    this.props.context.closeSnackbar();
  }

  signUp = () => {
    // Cas AUCUNE donnée venant des étapes antérieures
    if (!this.props.location.state) return this.props.history.push('/auth');

    const { type } = this.props.location.state;

    const { access_token } = this.state;

    const phone = transformPhone(this.props.phone);
    const {
      association: { association },
      firstName: first_name,
      lastName: last_name,
      address: city,
      email,
      password,
      associationUrl: url,
      longitude,
      latitude,
      department,
      handleOnSubmit,
      handleSignUp,
      context,
    } = this.props;

    // Cas données NON VALIDES dans le formulaire affiché
    const validations = [
      ...['association', 'address', 'email', 'password', 'confirmPassword', 'checkboxCgu'],
      ...(phone ? ['phone'] : []),
      ...(url ? ['associationUrl'] : []),
    ];

    if (!handleOnSubmit(validations)) return null;

    const body = {
      access_token,
      email,
      password,
      type,
      association,
      first_name,
      last_name,
      ...(phone && { phone }),
      ...(url && { url }),
      city,
      loc: [longitude, latitude],
      department,
    };

    handleSignUp('', body, context);
  };

  render() {
    const {
      classes,
      email,
      emailState,
      passwordState,
      confirmPasswordState,
      checkboxCgu,
      checkboxCguState,
      association,
      associationState,
      associationUrlState,
      firstName,
      firstNameState,
      lastName,
      lastNameState,
      addressState,
      phoneState,
      handleOnChange,
      handleChangeAddress,
      handleSelectAddress,
    } = this.props;
    const {
      closeSnackbar,
      state: { snackbar },
    } = this.props.context;

    const content = (
      <GridContainer justifyContent='center' className={classes.topMargin}>
        <ItemGrid xs={12} sm={6}>
          <CustomInput
            success={emailState === 'success'}
            error={emailState === 'error'}
            labelText={
              <span>
                Email <small>(obligatoire)</small>
              </span>
            }
            id='email'
            value={email || ''}
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: 'email',
              startAdornment: (
                <InputAdornment position='start'>
                  <Email className={classes.inputAdornmentIcon} />
                </InputAdornment>
              ),
              onChange: (event) => handleOnChange(event.target.value, 'email', 'email'),
            }}
            required
          />
          <CustomPasswordInput
            success={passwordState === 'success'}
            error={passwordState === 'error'}
            labelText={
              <span>
                Mot de passe <small>(obligatoire)</small>
              </span>
            }
            id='password'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: 'password',
              startAdornment: (
                <InputAdornment position='start'>
                  <LockOutlined className={classes.inputAdornmentIcon} />
                </InputAdornment>
              ),
              onChange: (event) => handleOnChange(event.target.value, 'password', 'password'),
            }}
            required
          />
          <CustomPasswordInput
            success={confirmPasswordState === 'success'}
            error={confirmPasswordState === 'error'}
            labelText={
              <span>
                Confirmez le mot de passe <small>(obligatoire)</small>
              </span>
            }
            id='confirmPassword'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: 'password',
              startAdornment: (
                <InputAdornment position='start'>
                  <LockOutlined className={classes.inputAdornmentIcon} />
                </InputAdornment>
              ),
              onChange: (event) => handleOnChange(event.target.value, 'confirmPassword', 'equalTo', 'password'),
            }}
            required
          />
          <CustomInput
            success={associationState === 'success'}
            error={associationState === 'error'}
            labelText={
              <span>
                Nom de l'association <small>(obligatoire)</small>
              </span>
            }
            id='association'
            value={association || ''}
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => handleOnChange(event.target.value, 'association', 'length', 3),
            }}
            required
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={6}>
          <CustomInput
            success={firstNameState === 'success'}
            error={firstNameState === 'error'}
            labelText={
              <span>
                Prénom <small>(obligatoire)</small>
              </span>
            }
            id='first-name'
            value={firstName || ''}
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => handleOnChange(event.target.value, 'firstName', 'length', 3),
            }}
            required
          />
          <CustomInput
            success={lastNameState === 'success'}
            error={lastNameState === 'error'}
            labelText={
              <span>
                Nom de famille <small>(obligatoire)</small>
              </span>
            }
            id='last-name'
            value={lastName || ''}
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => handleOnChange(event.target.value, 'lastName', 'length', 3),
            }}
            required
          />

          <SearchBar
            success={addressState === 'success'}
            error={addressState === 'error'}
            type={'(cities)'}
            labelText={
              <span>
                Ville <small>(obligatoire)</small>
              </span>
            }
            handleChange={handleChangeAddress}
            handleSelect={handleSelectAddress}
          />

          <CustomInput
            success={phoneState === 'success'}
            error={phoneState === 'error'}
            labelText='Téléphone'
            id='phone'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => handleOnChange(event.target.value, 'phone', 'optionnalLandline'),
            }}
          />
        </ItemGrid>

        <ItemGrid xs={12}>
          <CustomInput
            success={associationUrlState === 'success'}
            error={associationUrlState === 'error'}
            labelText='Lien internet'
            id='url'
            helpText='Vos coordonnées resteront confidentielles et ne seront pas transmises.'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => handleOnChange(event.target.value, 'associationUrl', 'optionnalUrl'),
            }}
          />
        </ItemGrid>
      </GridContainer>
    );

    // noinspection DuplicatedCode
    const footer = (
      <Fragment>
        <GridContainer direction='row' justifyContent='center' alignItems='center'>
          <ItemGrid>
            <Checkbox
              id='cgu-checkbox'
              onClick={() => handleOnChange(!checkboxCgu, 'checkboxCgu', 'checked')}
              value='cgu'
              checked={checkboxCgu ? 'checked' : ''}
              className={checkboxCguState === 'error' ? classes.checkboxError : ''}
              required
            />
          </ItemGrid>
          <ItemGrid>
            <label htmlFor='cgu-checkbox' style={{ cursor: 'pointer', userSelect: 'none' }}>
              J'ai lu et j'accepte les{' '}
              <a href='https://www.viensvoirmontaf.fr/mentions-legales/' rel='noopener noreferrer' target='_blank'>
                conditions générales d'utilisation de ViensVoirMonTaf
              </a>{' '}
              et j'atteste que les informations renseignées sont vraies
            </label>
          </ItemGrid>
        </GridContainer>
        <Button color='primary' onClick={() => this.signUp(this.props.context)}>
          Inscription
        </Button>
      </Fragment>
    );

    const snackbarContainer = snackbar && snackbar.isSnackbar && (
      <Snackbar
        key='snackbar'
        place='bc'
        color={snackbar.status}
        icon={AddAlert}
        message={snackbar.message}
        open={true}
        closeNotification={closeSnackbar}
        close
      />
    );

    return (
      <ErrorBoundaries>
        <div className={classes.content}>
          {snackbarContainer}
          <GridContainer justifyContent='center'>
            <ItemGrid xs={12} sm={10}>
              <form>
                <IconCard
                  icon={School}
                  iconColor='pink'
                  title='Formulaire association'
                  content={content}
                  footer={footer}
                  footerAlign='center'
                />
              </form>
            </ItemGrid>
          </GridContainer>
        </div>
      </ErrorBoundaries>
    );
  }
}

AssociationRegister.propTypes = {
  classes: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnSubmit: PropTypes.func.isRequired,
  handleChangeAddress: PropTypes.func.isRequired,
  handleSelectAddress: PropTypes.func.isRequired,
  association: PropTypes.object,
  associationState: PropTypes.string,
  phone: PropTypes.string,
  phoneState: PropTypes.string,
  address: PropTypes.string,
  addressState: PropTypes.string,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  department: PropTypes.string,
};

const WrappedComponent = FormHOC(AssociationRegister);

export default withStyles(detailsPageStyle)((props) => (
  <Context.Consumer>{(context) => <WrappedComponent {...props} context={context} />}</Context.Consumer>
));
